import { DeleteButton } from "src/components/Buttons/DeleteButton";
import { useAvelaToast } from "src/hooks/useAvelaToast";
import { useGlossary } from "src/hooks/useGlossary";
import { useRemoteDataMutation } from "src/hooks/useRemoteDataMutation";
import * as GQL from "src/types/graphql";
import { DELETE_SCHOOL } from "./graphql/mutations";

interface DeleteSchoolButtonProps {
  id: string;
  name: string;
  onDelete: () => void;
}

export const DeleteSchoolButton = ({
  id,
  name,
  onDelete,
}: DeleteSchoolButtonProps) => {
  const { glossary } = useGlossary();
  const [deleteSchool, { remoteData }] = useRemoteDataMutation<
    GQL.DeleteSchool,
    GQL.DeleteSchoolVariables
  >(DELETE_SCHOOL);

  const toast = useAvelaToast();

  const handleDelete = async () => {
    try {
      await deleteSchool({ variables: { id: id } });
      onDelete();
    } catch (error) {
      console.error(error);
      if (!toast.isActive(id)) {
        toast({
          id,
          title: glossary`Error deleting school`,
          description:
            "Please try again later or report the problem to our support team.",
          isClosable: true,
          status: "error",
        });
      }
    }
  };

  return (
    <DeleteButton
      label={`Edit ${name}`}
      loading={remoteData.isLoading()}
      onDelete={handleDelete}
      confirmationHeader={glossary`Delete school`}
    />
  );
};
